import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { Constants, characterActions } from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../actions/sidebar';
import { SidebarHeader } from '../../../components/Sidebar';
import { ThemeButton } from '../../../components/common/Button';
import { SharedAppState } from '../../../stores/typings';
import { PaneComponentEnum } from '../../../utils';
import { PaneIdentifiersPreferenceHitPointConfirm } from '../../../utils/PaneIdentifier/typings';

interface Props extends DispatchProp {
    identifiers: PaneIdentifiersPreferenceHitPointConfirm | null;
}
interface State {
    hitPointType: number | null;
}
class PreferencesHitPointConfirmPane extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);

        this.state = this.generateStateData(props);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
        const { identifiers } = this.props;

        if (identifiers !== prevProps.identifiers) {
            this.setState(this.generateStateData(this.props));
        }
    }

    generateStateData = (props: Props): State => {
        const { identifiers } = props;

        return {
            hitPointType: identifiers !== null ? identifiers.id : null,
        };
    };

    handleConfirm = (): void => {
        const { hitPointType } = this.state;
        const { dispatch } = this.props;

        dispatch(characterActions.preferenceChoose('hitPointType', hitPointType));
        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.PREFERENCES));
    };

    handleCancel = (): void => {
        const { dispatch } = this.props;
        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.PREFERENCES));
    };

    renderContent = (): React.ReactNode => {
        const { hitPointType } = this.state;

        switch (hitPointType) {
            case Constants.PreferenceHitPointTypeEnum.FIXED:
                return (
                    <React.Fragment>
                        <SidebarHeader>Fixed Hit Points</SidebarHeader>
                        <div className="change-preference-content">
                            <p>Are you sure you want to change your hit points to the fixed value?</p>
                            <p>Any rolled hit point totals will be lost.</p>
                        </div>
                    </React.Fragment>
                );

            case Constants.PreferenceHitPointTypeEnum.MANUAL:
                return (
                    <React.Fragment>
                        <SidebarHeader>Manual Hit Points</SidebarHeader>
                        <div className="change-preference-content">
                            <p>Are you sure you want to change your hit points to manual entry?</p>
                            <p>After doing so, use Manage HP in the Class section to enter your rolled values.</p>
                        </div>
                    </React.Fragment>
                );
        }

        return null;
    };

    render() {
        return (
            <div className="ct-preferences-pane">
                {this.renderContent()}
                <div className="ct-preferences-pane__actions">
                    <div className="ct-preferences-pane__action">
                        <ThemeButton onClick={this.handleConfirm}>Accept</ThemeButton>
                    </div>
                    <div className="ct-preferences-pane__action">
                        <ThemeButton onClick={this.handleCancel} style="outline">
                            Cancel
                        </ThemeButton>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {};
}

export default connect(mapStateToProps)(PreferencesHitPointConfirmPane);
